// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const CREATE_PROCEDURE_DATASET_STEP_SHAPES = [
  {
    stepType: PipelineStepType.CREATE_PROCEDURE_DATASET,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {},
    outputDataShapes: {
      outputDataFrame: {
        systemName: 'outputDataFrame',
        displayName: 'Output dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      seedItems: {
        kind: 'taggedUnion',
        required: true,
        tagKey: 'seedItemType',
        choices: [
          {
            kind: 'shape',
            required: true,
            fields: {
              seedItemType: {
                kind: 'string',
                required: true,
                value: 'STUDY'
              },
              seedItemIds: {
                kind: 'array',
                required: true,
                elementSpec: {
                  kind: 'domain',
                  required: true,
                  types: [
                    'STUDY'
                  ]
                },
                minItems: 1
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              seedItemType: {
                kind: 'string',
                required: true,
                value: 'PROCEDURE_RUN'
              },
              seedItemIds: {
                kind: 'array',
                required: true,
                elementSpec: {
                  kind: 'domain',
                  required: true,
                  types: [
                    'PROCEDURE_RUN'
                  ]
                },
                minItems: 1
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              seedItemType: {
                kind: 'string',
                required: true,
                value: 'WORKSHEET'
              },
              seedItemIds: {
                kind: 'array',
                required: true,
                elementSpec: {
                  kind: 'domain',
                  required: true,
                  types: [
                    'WORKSHEET'
                  ]
                },
                minItems: 1
              }
            }
          }
        ]
      },
      datasetConfig: {
        kind: 'taggedUnion',
        required: true,
        tagKey: 'procedureDatasetType',
        choices: [
          {
            kind: 'shape',
            required: true,
            fields: {
              procedureDatasetType: {
                kind: 'string',
                required: true,
                value: 'RESULT_SCHEMA'
              },
              procedureDatasetVersion: {
                kind: 'integer',
                required: true
              },
              sourceObjectId: {
                kind: 'domain',
                required: true,
                types: [
                  'RESULT_SCHEMA'
                ]
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              procedureDatasetType: {
                kind: 'string',
                required: true,
                value: 'ENTITY_SCHEMA'
              },
              procedureDatasetVersion: {
                kind: 'integer',
                required: true
              },
              sourceObjectId: {
                kind: 'domain',
                required: true,
                types: [
                  'ENTITY_SCHEMA'
                ]
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              procedureDatasetType: {
                kind: 'string',
                required: true,
                value: 'CONDITIONS'
              },
              procedureDatasetVersion: {
                kind: 'integer',
                required: true
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              procedureDatasetType: {
                kind: 'string',
                required: true,
                value: 'DATA_PARAMETER'
              },
              procedureDatasetVersion: {
                kind: 'integer',
                required: true
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              procedureDatasetType: {
                kind: 'string',
                required: true,
                value: 'MATERIAL_INPUT'
              },
              procedureDatasetVersion: {
                kind: 'integer',
                required: true
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              procedureDatasetType: {
                kind: 'string',
                required: true,
                value: 'MATERIAL_OUTPUT'
              },
              procedureDatasetVersion: {
                kind: 'integer',
                required: true
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              procedureDatasetType: {
                kind: 'string',
                required: true,
                value: 'EQUIPMENT'
              },
              procedureDatasetVersion: {
                kind: 'integer',
                required: true
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              procedureDatasetType: {
                kind: 'string',
                required: true,
                value: 'INDIVIDUAL_PLATE_POSITIONS'
              },
              procedureDatasetVersion: {
                kind: 'integer',
                required: true
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              procedureDatasetType: {
                kind: 'string',
                required: true,
                value: 'INDIVIDUAL_PLATE_CONTENTS'
              },
              procedureDatasetVersion: {
                kind: 'integer',
                required: true
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              procedureDatasetType: {
                kind: 'string',
                required: true,
                value: 'PLATE_SUMMARY'
              },
              procedureDatasetVersion: {
                kind: 'integer',
                required: true
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              procedureDatasetType: {
                kind: 'string',
                required: true,
                value: 'PLATE_RECORD_POSITIONS'
              },
              procedureDatasetVersion: {
                kind: 'integer',
                required: true
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              procedureDatasetType: {
                kind: 'string',
                required: true,
                value: 'PLATE_RECORD_CONTENTS'
              },
              procedureDatasetVersion: {
                kind: 'integer',
                required: true
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              procedureDatasetType: {
                kind: 'string',
                required: true,
                value: 'PLATE_DESIGN_POSITIONS'
              },
              procedureDatasetVersion: {
                kind: 'integer',
                required: true
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              procedureDatasetType: {
                kind: 'string',
                required: true,
                value: 'PLATE_DESIGN_CONTENTS'
              },
              procedureDatasetVersion: {
                kind: 'integer',
                required: true
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              procedureDatasetType: {
                kind: 'string',
                required: true,
                value: 'TEST_ORDERS'
              },
              procedureDatasetVersion: {
                kind: 'integer',
                required: true
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              procedureDatasetType: {
                kind: 'string',
                required: true,
                value: 'PREVIOUS_TEST_ORDERS'
              },
              procedureDatasetVersion: {
                kind: 'integer',
                required: true
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              procedureDatasetType: {
                kind: 'string',
                required: true,
                value: 'PMEI_ASSOCIATION'
              },
              procedureDatasetVersion: {
                kind: 'integer',
                required: true
              }
            }
          }
        ]
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
